import type { PropsWithChildren, JSX } from 'react';
import { useStyles } from '@archipro-design/aria';
import { DevicePreviewOverlay } from '@modules/root/component/device-preview/DevicePreview.style';
export const DevicePreview = ({ children }: PropsWithChildren): JSX.Element => {
    const { css } = useStyles();
    return <div className={css(DevicePreviewOverlay)}>{children}</div>;
};
